import { staticPageQuery } from './schema/static-page.schema'

class StaticPageService {
  constructor () {
    const { $apolloClient } = useNuxtApp()
    this.client = $apolloClient
    this.data = {}
  }

  getStaticPage = async ({ slug }) => {
    try {
      const data = await this.client.query({
        query: staticPageQuery(slug),
        variables: {}
      })

      return data.data.staticPageCollection.items[0]
    } catch (error) {
      return new Error(error)
    }
  }
}

export default StaticPageService
